import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NbCalendarRange, NbDateService, NbDialogRef } from '@nebular/theme';
import { ToastService } from '../../../@theme/service/toast.service';
import { Dates } from '../../util/dates';

@Component({
  selector: 'ngx-range-date-picker-dialog',
  template: `
    <nb-card style="max-width: 380px;">
        <nb-card-header>
            <h6>
                기간 설정
                <div>
                    {{ range.start | date: "yyyy/MM/dd"}} ~ {{ range.end | date: "yyyy/MM/dd"}}
                </div>
            </h6>
        </nb-card-header>
            <nb-calendar-range [(range)]="range" (dateChange)="changeDate($event)"></nb-calendar-range>
        <nb-card-footer>
            <div class="col-12 d-flex justify-content-end">
                <button *ngIf="range.start || range.end" class="mr-2" nbButton ghost size="small" (click)="reset()">초기화</button>
                <button class="mr-2" nbButton ghost size="small" status="primary" (click)="save()">적용</button>
                <button class="" nbButton ghost size="small" (click)="exit()">닫기</button>
            </div>
        </nb-card-footer>
    </nb-card>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class RangePickerComponent implements OnInit {

    range: NbCalendarRange<Date>;

    from: Date;
    to: Date;
  
    constructor(protected dateService: NbDateService<Date>,
      private ref: NbDialogRef<RangePickerComponent>,
      private toast: ToastService) { }
  
    ngOnInit(): void {
      if (this.from && this.to)
        this.range = { start: this.from, end: this.to };
      else
        this.range = { start: new Date(), end: new Date() };
    }
  
    changeDate(changeRange: any) {
    }
  
    save() {
      if (Dates.diff(this.range.end, this.range.start) < 0)
        return this.toast.info("시작일보다 종료일이 이전입니다.");
  
      this.ref.close(this.range);
    }
  
    exit() {
      this.ref.close();
    }

}